import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'
import _ from 'lodash'
import bowser from 'bowser'

import { LOCALE_PREFIX, LEVELS_WITH_HISTORY } from './constants'

import './style.scss'

const browser = bowser.getParser(typeof window !== 'undefined' ? window.navigator.userAgent : 'UA')

export default class Tabs extends Component {
    static propTypes = {
        counter: PropTypes.shape({
            left: PropTypes.oneOfType([
                PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                PropTypes.shape({
                    count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                    color: PropTypes.string,
                }),
            ]),
            right: PropTypes.oneOfType([
                PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                PropTypes.shape({
                    count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                    color: PropTypes.string,
                }),
            ]),
        }),
        disabled: PropTypes.bool,
        index: PropTypes.number.isRequired,
        inline: PropTypes.bool.isRequired,
        isActive: PropTypes.bool,
        level: PropTypes.string.isRequired,
        locked: PropTypes.bool,
        onClick: PropTypes.func,
        overrideOnClick: PropTypes.func,
        showNewBanner: PropTypes.bool,
        subtitle: PropTypes.string,
        tabsId: PropTypes.string.isRequired,
        title: PropTypes.string,
    }

    static defaultProps = {
        disabled: false,
        isActive: false,
        locked: false,
        showNewBanner: false,
        onClick: () => {},
        overrideOnClick: null,
        subtitle: null,
        title: '',
    }

    onClickHandler = () => {
        const { tabsId, disabled, index, onClick, overrideOnClick } = this.props

        if (overrideOnClick) overrideOnClick(tabsId, index)
        if (!disabled && !overrideOnClick && onClick) onClick(index)
    }

    renderCounter = () => {
        const { counter, level } = this.props

        let leftCounterValue = 0
        if (!_.isNil(counter.left)) leftCounterValue = _.get(counter, 'left.count', counter.left)
        let rightCounterValue = 0
        if (!_.isNil(counter.right)) rightCounterValue = _.get(counter, 'right.count', counter.right)

        return (
            <div className={'general-tabs-tab-counter'}>
                {!_.isNil(counter.left) && (
                    <div
                        className={'general-tabs-tab-counter-left'}
                        style={{ color: _.get(counter, 'left.color', null) }}
                    >
                        {leftCounterValue}
                    </div>
                )}
                {!_.isNil(counter.left) && !_.isNil(counter.right) && LEVELS_WITH_HISTORY.includes(level) && (
                    <div className={'general-tabs-tab-counter-slash'}>{'/'}</div>
                )}
                {!_.isNil(counter.right) && LEVELS_WITH_HISTORY.includes(level) && (
                    <div
                        className={'general-tabs-tab-counter-right'}
                        style={{ color: _.get(counter, 'right.color', null) }}
                    >
                        {rightCounterValue}
                    </div>
                )}
            </div>
        )
    }

    renderSubtitle = () => {
        const { subtitle, counter, level } = this.props

        if (subtitle) return subtitle

        if (LEVELS_WITH_HISTORY.includes(level) && !_.isNil(counter.left) && !_.isNil(counter.right))
            return <FormattedMessage id={`${LOCALE_PREFIX}.historySubtitle`} />

        return <FormattedMessage id={`${LOCALE_PREFIX}.noHistorySubtitle`} />
    }

    render() {
        const { isActive, subtitle, title, counter, disabled, locked, inline, overrideOnClick, showNewBanner } =
            this.props

        return (
            <div
                className={cx(
                    'general-tabs-tab',
                    browser.is('Internet Explorer') && 'ie',
                    !disabled && isActive && 'active',
                    disabled && 'disabled',
                    locked && 'locked',
                    inline && 'inline',
                    overrideOnClick && 'clickable'
                )}
                onClick={this.onClickHandler}
            >
                <div className={'general-tabs-tab-content'}>
                    <div className={cx('general-tabs-tab-title', inline && showNewBanner && 'with-new-banner')}>
                        <span title={title}>{title}</span>
                        {showNewBanner && (
                            <span className={'general-tabs-tab-new-banner'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.new`} />
                            </span>
                        )}
                    </div>
                    <div>
                        {(disabled || locked) && <div className={'general-tabs-tab-image'} />}
                        {!disabled && !locked && counter && !inline && this.renderCounter()}
                        {!disabled && !locked && !inline && (
                            <div className={'general-tabs-tab-subtitle'}>
                                <span title={subtitle}>{this.renderSubtitle()}</span>
                            </div>
                        )}
                        {!disabled && locked && !inline && (
                            <div className={'general-tabs-tab-subtitle'}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.unavailable`} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}
